import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import "./Wishlist.css";

const Wishlist = () => {
  return (
    <div className="Wishlist">
      <Header />
      <SubHeader title="Wishlist" text="Wishlist" width='container' />
      <div className="cart-container py-5">
        <div className="container ">
          <table className="Wishlist_table table table-borderless text-white">

            <thead>
              <tr >
                <th class="product-remove w5 p-0">
                  <span class="nobr">
                  </span>
                </th>
                <th class="product-thumbnail w20 p-0">product</th>
                <th class="product-name w45 p-0">
                  <span class="nobr">
                    Description </span>
                </th>
                <th class="product-price w10 p-0">
                  <span class="nobr">
                    Unit price </span>
                </th>
                <th class="product-stock-status w10 p-0">
                  <span class="nobr">
                    Stock status </span>
                </th>
                <th class="product-add-to-cart w10 p-0">
                  <span class="nobr">
                    Action
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>

              <tr className='btm_border_dash'>
                <td className="product-remove w5">
                  <div className="icon cursor d-flex align-items-center justify-content-center">
                    <img
                      src={require("../../Asset/cart/Essentials/bin.png")}
                      alt="Delete Icon"
                    />
                    {/* <FontAwesomeIcon icon={faTrashAlt}/> */}
                  </div>
                </td>
                <td className="product-thumbnail w20">
                  <Link to="" >
                    <div className="cart-img">
                      <img src={require("../../Asset/blog/Group 229.png")} alt="Product" />
                    </div>
                  </Link>
                </td>
                <td className="product-name w45">
                  Abstract Oil Painting
                  <br />
                  By <span className="cl-pm">Kaven Morgan</span>,
                  <span> Size: 15”x10”</span>
                </td>
                <td className="product-price w10">$150.00</td>
                <td className="product-stock-status w10 cl-lightpink">Out of Stock</td>
                <td className="product-add-to-cart w10">
                  <Link to="" className="fixed_btn">Add to Cart</Link>
                </td>
              </tr>


              <tr className='btm_border_dash'>
                <td className="product-remove w5">
                  <div className="icon cursor d-flex align-items-center justify-content-center">
                    <img
                      src={require("../../Asset/cart/Essentials/bin.png")}
                      alt="Delete Icon"
                    />
                    {/* <FontAwesomeIcon icon={faTrashAlt}/> */}
                  </div>
                </td>
                <td className="product-thumbnail w20">
                  <Link to="" >
                    <div className="cart-img">
                      <img src={require("../../Asset/cart/Group 280.png")} alt="Product" />
                    </div>
                  </Link>
                </td>
                <td className="product-name w45">
                  Abstract Oil Painting
                  <br />
                  By <span className="cl-pm">Kaven Morgan</span>,
                  <span> Size: 15”x10”</span>
                </td>
                <td className="product-price w10">$150.00</td>
                <td className="product-stock-status w10 cl-lightgreen">In Stock</td>
                <td className="product-add-to-cart w10">
                  <Link to="" className="fixed_btn">Add to Cart</Link>
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Wishlist;
